import React, { useState } from 'react';
import { UnmountClosed } from 'react-collapse';
import styled from 'styled-components';
import { BodyLink, NextIcon, WarrantyIcon } from '@kvdbil/components';
import {
  getWarrantyDescription,
  getWarrantyHeading
} from '~/helpers/additionalServices';
import { calculateWarranty } from '~/helpers/calculator';
import { useTranslation } from '~/Locale';
import AdditionalServicesLoader from './AdditionalServicesLoader';
import Header from './Header';
import { CMSDataObjectPageService } from '~/App/views/ObjectPage/cmsDataHandlers';
import { ServiceStructuredText } from './ServiceStructuredText';
import { ServiceContainer } from '..';
import Link from '~/App/shared/components/Link';

interface Props {
  cmsData?: CMSDataObjectPageService;
  carAge: number;
  odometerReading: number;
}

const ServiceInformation = styled.div`
  padding: 1rem;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
`;

const WarrantyService = ({ cmsData, odometerReading, carAge }: Props) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = () => setIsExpanded(!isExpanded);

  if (!cmsData) {
    return <AdditionalServicesLoader service="Warranty" />;
  }

  const warrantyType = calculateWarranty(odometerReading, carAge);
  const ariaControls = 'additional-service-warranty-content';

  return (
    <ServiceContainer>
      <Header
        isExpanded={isExpanded}
        toggleExpanded={toggleExpanded}
        icon={cmsData?.icon ?? WarrantyIcon}
        responsiveImage={cmsData?.image?.responsiveImage}
        title={getWarrantyHeading(warrantyType, t)}
        description={getWarrantyDescription(warrantyType, t)}
        ariaControls={ariaControls}
      />
      <UnmountClosed isOpened={isExpanded}>
        <ServiceInformation id={ariaControls}>
          <ServiceStructuredText data={cmsData?.content} />
          <StyledLink to={cmsData?.link?.[0]?.url ?? ''} target="_blank">
            <BodyLink as="span">{cmsData?.link?.[0]?.text}</BodyLink>
            <NextIcon />
          </StyledLink>
        </ServiceInformation>
      </UnmountClosed>
    </ServiceContainer>
  );
};

export default WarrantyService;
